import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { fromEvent, Subject } from 'rxjs';
import { ElectionService } from 'src/app/services/election.service';
import { LgElectionService } from 'src/app/services/lg-election.service';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { takeUntil } from 'rxjs/operators';
import { ISelectPage } from 'src/app/interfaces/ISelectPage';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-navigation-lge',
  templateUrl: './navigation-lge.component.html',
  styleUrls: ['./navigation-lge.component.scss']
})
export class NavigationLGEComponent implements OnInit {

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  public subTitle = '';
  public PageTypeEnum = PageTypeEnum;
  public showSideNav = false;

  public isMobile = false;
  public isTablet = false;
  public isDesktop = false;
  public currentPage: PageTypeEnum = PageTypeEnum.Loading;



  public options = {
    bottom: 0,
    fixed: true,
    top: 100
  };
  public optionsPhone = {
    bottom: 0,
    fixed: true,
    top: 60
  };
  public cols = 3;


  constructor(
    public lgElectionService: LgElectionService,
    private changeDetectorRef: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private activatedRoute: ActivatedRoute
  ) { 
    this.lgElectionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(selectPage => {
      this.currentPage = selectPage.pageType;
      this.changeDetectorRef.detectChanges();
    });

    this.lgElectionService.menuPhoneClick$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.showSideNav = false;
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const councilCode = params['council'];
      const electionDate = params['date'];
      if (councilCode && councilCode.length === 3) {
        this.lgElectionService.selectedCouncilCode = councilCode;
      }
      if (electionDate && electionDate.length >= 8 && electionDate.length <= 10) {
        this.lgElectionService.selectedElectionDate = electionDate;
      }
      
    });

    this.checkResize();
    fromEvent(window, 'resize').subscribe(e => {
       this.checkResize();
    });
  }

  private checkResize(): void {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktop = this.deviceService.isDesktop();
    this.lgElectionService.isMobile = this.isMobile;
    this.lgElectionService.isTablet = this.isTablet;
    this.lgElectionService.isDesktop = this.isDesktop;
  }


  toggleSideNav = () => {
    this.showSideNav = !this.showSideNav;
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

}
